<template>
   <node-view-wrapper class="citaat">
      <div @click="openModal()">
         <node-view-content class="citaat-content" />
         <div class="modal" v-show="showModal">
            ref:
            <input
               type="text"
               ref="inputField"
               @blur="showModal = false"
               v-model="refContent"
            />
         </div>
      </div>
   </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from "@tiptap/vue-2";

export default {
   components: {
      NodeViewWrapper,
      NodeViewContent,
   },
   props: nodeViewProps,
   data() {
      return {
         showModal: false,
         refContent: "",
      };
   },
   methods: {
      openModal() {
         console.log(this.$el);
         this.showModal = true;
         //  this.$refs.inputField.focus();
         this.$nextTick(() => this.$refs.inputField.focus());
      },
   },
   watch: {
      "node.textContent": {
         handler(newVal) {
            this.node.attrs.value = newVal;
         },
         immediate: true,
      },
      refContent(newVal) {
         this.node.attrs.ref = newVal;
      },
   },
};
</script>

<style lang="scss">
.citaat {
   // background-color: #fff;
   // border: 1px solid #ddd;
   // border-radius: 0.5rem;
   // margin: 1rem 0;
   // position: relative;
   // width: 95%;
   // max-width: 1200px;
   display: inline-block;
   position: relative;
   &.has-focus {
      color: red;
   }
}

.citaat-content {
   color: blue;
   // margin: 2.5rem 1rem 1rem;
   // padding: 0.5rem;
   // border: 2px dashed #0d0d0d20;
   // border-radius: 0.5rem;
}

.modal {
   position: absolute;
   left: 100%;
   background-color: #fff;
   padding: 0.5rem;
   box-shadow: var(--box-shadow);
   z-index: 2;
}

// .modal {
//    position: fixed;
//    width: 100vw;
//    height: 100vh;
//    left: 0;
//    top: 0;
//    background-color: rgba(0,0,0,.2);
//    box-shadow: var(--box-shadow);
//    z-index: 999;
//    pointer-events: none;
//    .container {
//       position: absolute;
//       inset: 0;
//       width: 400px;
//    }
// }
</style>
